import * as React from 'react';

export interface DonationIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * DonationIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Donation account. Donation box with white heart label and gold coin entering through the slot.
 */
const DonationIcon: React.FunctionComponent<DonationIconProps> = ({
  className,
  size = 40,
  title = 'Donation Account',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="10" y="20" width="28" height="22" rx="1.5" fill="#a8226e"/>
      <rect x="9" y="18" width="30" height="3" rx="0.5" fill="#671343"/>
      <rect x="20" y="19" width="8" height="1" fill="#3a0a26"/>
      <path d="M24 36 Q18 30 18 26 Q18 23 20.5 23 Q22.5 23 24 25.5 Q25.5 23 27.5 23 Q30 23 30 26 Q30 30 24 36 Z" fill="#FFFFFF"/>
      <circle cx="24" cy="11" r="4" fill="#d4a958" stroke="#8a6a2c" strokeWidth="0.8"/>
      <text x="24" y="13" textAnchor="middle" fontFamily="serif" fontSize="5" fontWeight="700" fill="#FFFFFF">$</text>
  </svg>
);

export default DonationIcon;
